import { Outlet } from 'react-router-dom'
import { NavBar } from './nav-bar'

export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <NavBar />
      <main className="flex-1 bg-muted/30 p-4 sm:p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  )
}
